<template>
  <c-modal
    class="c-loginModal"
    title="会員登録"
    width="560px"
    :active="active"
    @close="$emit('close')"
  >
    <p class="c-loginModal_description">サービスを利用するには、登録またはログインをしてください。</p>
    <div class="c-loginModal_links">
      <div class="c-signUpButtons">
        <!--環境に応じてボタンの並び順を変更。PC:G,Y,F,A / iOS:G,Y,A,F / Android:G,Y,F,A -->
        <a
          :href="$coconala.getRedirectURL($ua.isFromSmartphone() ? '/smartphone/login/Google' : '/login/Google')"
          class="c-signUpButtons_socialButton"
        >
          <img
            src="@/assets/images/common/logo-google.png"
            alt="Google"
          >
          <span>Googleで登録する</span>
        </a>
        <a
          :href="$coconala.getRedirectURL($ua.isFromSmartphone() ? '/smartphone/login/YahooJapan' : '/login/YahooJapan')"
          class="c-signUpButtons_socialButton"
        >
          <img
            src="@/assets/images/common/logo-yahoo.png"
            alt="Yahoo! JAPAN"
          >
          <span>Yahoo! JAPAN IDで登録する</span>
        </a>
        <a
          v-if="!$ua.isFromIos()"
          :href="$coconala.getRedirectURL($ua.isFromSmartphone() ? '/smartphone/login/Facebook' : '/login/Facebook')"
          class="c-signUpButtons_socialButton"
        >
          <img
            src="@/assets/images/common/logo-facebook.png"
            alt="Facebook"
          >
          <span>Facebookで登録する</span>
        </a>
        <a
          :href="$coconala.getRedirectURL($ua.isFromSmartphone() ? '/smartphone/login/Apple' : '/login/Apple')"
          class="c-signUpButtons_socialButton"
        >
          <img
            src="@/assets/images/common/logo-apple.png"
            alt="Apple"
          >
          <span>Appleで登録する</span>
        </a>
        <a
          v-if="$ua.isFromIos()"
          :href="$coconala.getRedirectURL($ua.isFromSmartphone() ? '/smartphone/login/Facebook' : '/login/Facebook')"
          class="c-signUpButtons_socialButton"
        >
          <img
            src="@/assets/images/common/logo-facebook.png"
            alt="Facebook"
          >
          <span>Facebookで登録する</span>
        </a>
      </div>
      <p class="c-loginModal_orText">または</p>
      <c-button-v2
        class="c-loginModal_emailRegister"
        :href="$coconala.registrationURL()"
        size="m"
        width="100%"
        color="primary"
        iconName="envelope-o"
        iconSize="20px"
        noShadow
      >
        メールアドレスで登録
      </c-button-v2>
      <hr>
      <p class="c-loginModal_loginLink"><a :href="$coconala.loginURL()">ログインはこちら</a></p>
    </div>
  </c-modal>
</template>

<script>
export default {
  name: 'LoginModal',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  @include link-effect;
}

.c-loginModal {
  &_description {
    text-align: center;
  }

  &_links {
    margin: 32px auto 0;
    width: 346px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &_orText {
    margin-top: 16px;
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 10px;
    color: $color-gray-600;
    &::before,
    &::after {
      content: '';
      flex-grow: 1;
      height: 1px;
      background: $color-gray-200;
      display: block;
    }
    &::before {
      margin-right: 8px;
    }
    &::after {
      margin-left: 8px;
    }
  }

  &_emailRegister {
    width: 100%;
  }

  hr {
    margin: 16px 0;
    width: 100%;
    height: 0;
    border-top: 1px solid $color-gray-200;
  }

  &_loginLink {
    text-align: center;
    font-size: 12px;
    font-weight: bold;
  }

  /deep/ .c-modal {
    &_body {
      padding: 32px 16px;
    }
  }
}

.c-signUpButtons {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 212px;
  width: 100%;

  &_socialButton {
    display: flex;
    align-items: center;
    height: 44px;
    padding-left: 12px;
    border: 1px solid $color-gray-300;
    border-radius: 5px;
    color: $color-black;
    font-size: 14px;
    font-weight: bold;
    img {
      width: 24px;
    }
    span {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
  }
}

@media (max-width: $breakpoint-m) {
  .c-loginModal {
    /deep/ .modal-content {
      max-width: 440px !important;
    }
  }
}

@media (max-width: $breakpoint-s) {
  .c-loginModal {
    /deep/ .modal-content {
      max-width: calc(100vw - 40px) !important;
      height: 490px;

      .c-modal {
        &_inner {
          height: 488px;
        }
        &_body {
          min-height: 442px;
          padding: 16px;
        }
      }
    }

    &_links {
      margin-top: 12px;
      width: 244px;
    }

    &_loginLink {
      margin-bottom: 0;
    }
  }

  .c-signUpButtons {
    &_socialButton {
      font-size: 13px;
    }
  }
}
</style>
